import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UiTranslationService } from '@core/services/ui-translation.service';

@Component({
  selector: 'app-restore-version-confirm-modal',
  template: `
    <div class="modal-header border-bottom-0">
      <h5 class="modal-title d-flex align-items-center">
        <svg class="sa-icon me-2 sa-icon-warning sa-icon-2x sa-bold">
          <use href="/assets/icons/sprite.svg#alert-triangle"></use>
        </svg>
        {{ t()['restoreVersionConfirmTitle'] }}
      </h5>
      <button
        type="button"
        class="btn-close"
        [attr.aria-label]="t()['restoreVersionConfirmCancel']"
        (click)="activeModal.dismiss()"
      ></button>
    </div>

    <div class="modal-body border-bottom-0 fw-300 fs-sm">
      {{ t()['restoreVersionConfirmBody'] }}
    </div>

    <div class="modal-footer border-top-0">
      <button
        type="button"
        class="btn btn-light"
        (click)="activeModal.close(false)"
      >
        {{ t()['restoreVersionConfirmCancel'] }}
      </button>
      <button type="button" class="btn btn-primary" (click)="confirm()">
        {{ t()['restoreVersionConfirmAction'] }}
      </button>
    </div>
  `,
  styles: [
    `
      :host ::ng-deep .modal-restore-alert.modal .modal-content {
        background-color: rgba(25, 32, 47, 0.85);
        border-left: 0;
        border-right: 0;
        box-shadow: var(
          --sa-box-shadow-5,
          0 0.75rem 1.5rem rgba(0, 0, 0, 0.35)
        );
        color: var(--bs-light);
      }
    `,
  ],
})
export class RestoreVersionConfirmModal {
  readonly activeModal = inject(NgbActiveModal);
  private readonly translations =
    inject(UiTranslationService).namespace('mindmap');
  readonly t = this.translations.t;

  confirm(): void {
    this.activeModal.close(true);
  }
}
